import script from "./Navbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=547efa52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\Projects\\Commercial\\GEMA\\Ga-East-Municipal-Assembly\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547efa52"]])

export default __exports__